// Card de estado finalizado para propiedades cerradas

import React from 'react';
import { CheckCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * Card que se muestra cuando la propiedad está cerrada
 * Indica que el periodo de ofertas ha finalizado
 */
export const ClosedStatusCard = () => {
  const { t } = useTranslation();
  return (
    <div className="bg-slate-800/50 backdrop-blur-xl rounded-xl p-4 border border-slate-700/50">
      <div className="flex items-center gap-3 mb-2">
        <div className="bg-slate-700/50 p-2 rounded-lg flex-shrink-0">
          <CheckCircle className="w-5 h-5 text-slate-400" />
        </div>
        <h3 className="text-base font-semibold text-white">{t('closed.title')}</h3>
      </div>
      <p className="text-sm text-slate-400">
        {t('closed.desc')}
      </p>
    </div>
  );
};

export default ClosedStatusCard;
